import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const ChargeIdSchema = z.string().brand<'charge-id'>()

export type ChargeId = ZodSimplify<typeof ChargeIdSchema>

export const ChargeId = (value: string = generateRandomString()) => {
  return ChargeIdSchema.parse(value)
}
